/* @flow */

import { callApiEndpoint } from './index';
import type { Endpoint, OnDemand } from 'types';
import utils from './utils';

const submit = async (request: OnDemand): Promise<boolean> => {
  const endpoint: Endpoint = 'mailrequest/send-quotation-request';
  const mailRequest = utils.toMailRequest(request);
  if (!mailRequest) {
    return false;
  }
  await callApiEndpoint(endpoint, mailRequest);
  return true;
};

export default {
  submit,
};
